import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useCallback, useEffect, useId, useMemo, useState } from 'react';
import { createRebuyOutbound } from '../api/outbound/commonOutbounds';
import { FREE_CHIPS_REBUY_AMOUNT } from '../constants/constants';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { PlusCircleIcon } from '../icons/plusCircleIcon';
import { clearRebuyDelay } from '../redux/actions/selfDataActions';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { getCurrencyAmountString } from '../utils/currencyUtils';
import { CountdownTimerDisplay } from './countdownTimer/countdownTimerDisplay';
const BUTTON_LABEL_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 90%;
`;
const BUTTON_SUB_LABEL_CSS = css `
  opacity: 50%;
`;
const IN_TEXT_CSS = css `
  opacity: 0.7;
`;
function getIsRebuyEnabledNow(rebuyAvailableTimestampMs) {
    if (rebuyAvailableTimestampMs === undefined) {
        return true;
    }
    return rebuyAvailableTimestampMs <= performance.now();
}
export const RebuyButton = ({ onClicked }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const elementId = useId();
    const rebuyAvailableTimestampMs = useAppSelector((state) => state.selfData.rebuyAvailableTimestampMs);
    const [isRebuyEnabled, setIsRebuyEnabled] = useState(getIsRebuyEnabledNow(rebuyAvailableTimestampMs));
    const onClick = useCallback(() => {
        socketSend(createRebuyOutbound());
        onClicked?.();
    }, [onClicked, socketSend]);
    const onTimerEnd = useCallback(() => {
        dispatch(clearRebuyDelay());
    }, [dispatch]);
    useEffect(() => {
        setIsRebuyEnabled(getIsRebuyEnabledNow(rebuyAvailableTimestampMs));
    }, [rebuyAvailableTimestampMs]);
    const containerCss = useMemo(() => {
        return css(css `
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        gap: 0 5px;
        font-size: 120%;
      `, rebuyAvailableTimestampMs &&
            css `
          padding: 5px;
          border-radius: 5px;
          background-color: rgba(0, 0, 0, 0.2);
          border: 1px solid black;
        `);
    }, [rebuyAvailableTimestampMs]);
    return (_jsxs("div", { "aria-labelledby": elementId, css: containerCss, children: [_jsx(Button, { variant: 'contained', onClick: onClick, disabled: !isRebuyEnabled, startIcon: _jsx(PlusCircleIcon, {}), children: _jsxs("div", { css: BUTTON_LABEL_CSS, children: [_jsx("span", { id: elementId, children: "Free Rebuy" }), isRebuyEnabled && (_jsxs("span", { css: BUTTON_SUB_LABEL_CSS, children: ["Get ", getCurrencyAmountString(FREE_CHIPS_REBUY_AMOUNT, 'chips')] }))] }) }), !isRebuyEnabled && rebuyAvailableTimestampMs !== undefined ? (_jsxs(Typography, { component: 'span', children: [_jsx("span", { css: IN_TEXT_CSS, children: "in" }), ' ', _jsx(CountdownTimerDisplay, { endTimestampMs: rebuyAvailableTimestampMs, onTimerEnd: onTimerEnd, digitWidth: 8 })] })) : null] }));
};
